import { Box, Chip, Stack, Typography } from "@mui/material";

export default function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  status,
  sx,
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      gap={2.25}
      sx={{
        mb: 3.25,
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography
            variant="overline"
            sx={{ color: "primary.main", fontWeight: 900, letterSpacing: "0.11em" }}
          >
            {eyebrow}
          </Typography>
        )}
        <Stack
          direction="row"
          spacing={1.25}
          useFlexGap
          sx={{ alignItems: "center", flexWrap: "wrap" }}
        >
          <Typography variant="h4" sx={{ fontSize: { xs: "1.8rem", sm: "2.1rem" } }}>
            {title}
          </Typography>
          {status && (
            <Chip
              size="small"
              label={status.label}
              color={status.color || "default"}
              variant={status.variant || "filled"}
              sx={status.sx}
            />
          )}
        </Stack>
        {description && (
          <Typography color="text.secondary" sx={{ mt: 0.75, maxWidth: 760, lineHeight: 1.65 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: { xs: "flex-start", md: "flex-end" },
            width: { xs: "100%", md: "auto" },
            flexShrink: 0,
            "& .MuiButton-root": {
              minHeight: 40,
              height: 40,
              px: 1.75,
              borderRadius: 2.5,
              fontSize: "0.875rem",
              fontWeight: 800,
              whiteSpace: "nowrap",
              alignSelf: "center",
            },
            "& .MuiButton-contained": {
              backgroundImage: "none",
              bgcolor: "primary.main",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "primary.dark",
                boxShadow: "0 5px 14px rgba(37, 99, 235, 0.18)",
              },
            },
            "& .MuiButton-outlined": {
              borderColor: "#cbd5e1",
              color: "text.primary",
              bgcolor: "#fff",
              boxShadow: "none",
              "&:hover": {
                borderColor: "#94a3b8",
                bgcolor: "#f8fafc",
              },
            },
            "& .MuiIconButton-root": {
              width: 40,
              height: 40,
              borderRadius: 2.5,
              border: "1px solid #cbd5e1",
              bgcolor: "#fff",
              color: "text.primary",
              "&:hover": {
                borderColor: "#94a3b8",
                bgcolor: "#f8fafc",
              },
            },
            "& .MuiChip-root": {
              height: 40,
              alignSelf: "center",
            },
          }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
